import React, { useCallback, useEffect, useState } from 'react';

import { pausedStatementIcon } from '@europrocurement/l2d-icons';
import { useNavigate } from 'react-router';
import { useAchatsService, useSociete } from '@europrocurement/l2d-domain';
import { WidgetWithAction } from '@europrocurement/l2d-modules';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';

// interne

const RelevesNonClotures: React.FunctionComponent = function () {
    const navigate = useNavigate();

    const xIdSociete = useSociete();

    const [countOfUnclosedStatements, setCountOfUnclosedStatements] = useState<string>();

    const { releveAchatApi } = useAchatsService();

    const fetchCount = useCallback(() => {
        releveAchatApi
            .getRelevesAchatsReleveAchatCollection({
                xIdSociete,
                page: 1,
                itemsPerPage: 0,
                cloture: false,
                deleted: false,
            })
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfUnclosedStatements(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [releveAchatApi, xIdSociete]);

    useEffect(() => {
        fetchCount();
    }, [fetchCount]);

    const actionCallback = useCallback(async () => {
        navigate(achatsViewPathResolver('listInvoiceStatement'));
    }, [navigate]);

    return (
        <WidgetWithAction
            title="Relevés non clôturés"
            icon={pausedStatementIcon}
            actionMessage="Traiter"
            actionCallback={actionCallback}
            data={countOfUnclosedStatements}
            color="orange"
            onRetryData={fetchCount}
        />
    );
};

export default RelevesNonClotures;
